function Directive($compile) {
  "ngInject";
  return {
    restrict: "A",
    link: (scope, element, attrs) => {
      scope.$watch(
        () => {
          return scope.$eval(attrs.bindHtml);
        },
        (value) => {
          let compileScope = scope;
          element.html(value && value.toString());

          if (attrs.bindHtmlScope) {
            compileScope = scope.$eval(attrs.bindHtmlScope);
          }
          $compile(element.contents())(compileScope);
        }
      );
    },
  };
}

export default Directive;



// WEBPACK FOOTER //
// ./src/directives/bindHtml/bindHtml.directive.js